module.exports = __webpack_public_path__ + "img/right-white.89a457c3.png";